import { render, staticRenderFns } from "./BathModel.vue?vue&type=template&id=0e6fa84e&scoped=true"
import script from "./BathModel.vue?vue&type=script&lang=js"
export * from "./BathModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6fa84e",
  null
  
)

export default component.exports